export default __webpack_public_path__ + "assets/audio/1-50288889_clip.mp3";